module.exports = __webpack_public_path__ + "img/obj.6cae028c.svg";